/**
 * Map between game route pathnames and manual chapter ids.
 * Used by the FAB button to open the manual on the most relevant chapter
 * for what the player is currently doing.
 */

const ROUTE_TO_CHAPTER = {
  // Fiscalité — TVA, statuts juridiques
  '/fiscalite':  'fiscalite',
  // Finance & Comptabilité
  '/finance':    'finance',
  '/capitaux':   'finance',
  // Banque & Crédit
  '/banque':     'banque',
  // RH
  '/hr':         'rh',
  // Transport & Logistique
  '/fleet':      'transport',
  '/marche':     'transport',
  '/depot':      'transport',
  // M&A & Stratégie
  '/concurrence': 'ma',
  '/strategie':   'ma',
  '/fonctions-support': 'ma',
};

export function getChapterForRoute(pathname) {
  if (!pathname) return null;
  // Direct hit
  if (ROUTE_TO_CHAPTER[pathname]) return ROUTE_TO_CHAPTER[pathname];
  // Match on the first segment (e.g. /fiscalite/edit → /fiscalite)
  const root = '/' + (pathname.split('/').filter(Boolean)[0] || '');
  return ROUTE_TO_CHAPTER[root] || null;
}
